module.exports = __webpack_public_path__ + "media/images/new/mobile/icons/doctor_with_lens-326a06bc2ddb6fbeb2b5ed48d5756e8c.png";